export enum EntityStatus {
  current = 'current',
  completed = 'completed',
  locked = 'locked',
}

export enum EntityType {
  level = 'LEVEL',
  module = 'MODULE',
  step = 'STEP',
}

export interface ProgressionEntity {
  id: number;
  title: string;
  name: string;
  description: string;
  fullUrl: string;
}

export interface CurrentStep extends ProgressionEntity {
  fullUrl: string;
  status: 'current';
}

// This whole interface is never used by the FE, it needs to be removed from the response
export interface LastStep {
  category?: 'video' | 'lifeact' | 'certificate' | null;
  description: string;
  fullUrl: string;
  id: number;
  lft: number;
  name: string;
  status: EntityStatus;
  title: string;
  stepable_id: number; // BE only
  stepable_type: string; // BE only
  slug: string; // BE only
  type: string;
  hideStepInMenu: 0 | 1;
  congrats: string;
  rgt: number;
  depth: number;
  created_at: string;
  updated_at: string;
  deleted_at: null | string;
  order: number;
  parent_id: null;
  pivot: {
    participant_id: number;
    step_id: number;
    step_order: number;
    created_at: string; // '2024-03-21 13:54:45';
    updated_at: string; // '2024-03-21 13:54:45';
  };
  module: {
    id: number;
    cycle_id: number;
    title: string;
    name: string;
    description: string;
    content: null;
    slug: string;
    lft: number;
    rgt: number;
    depth: number;
    parent_id: null;
    created_at: string; // '2024-03-21 13:54:45';
    updated_at: string; // '2024-03-21 13:54:45';
    deleted_at: null | string;
    description_overridden: 0 | 1;
    custom_description: null | string;
    fullUrl: string;
    cycle: {
      id: number;
      course_id: number;
      title: string;
      name: string;
      description: string;
      slug: string;
      content: null;
      lft: number;
      rgt: number;
      depth: number;
      parent_id: null;
      created_at: string | null; // '2024-03-21 13:54:45';
      updated_at: string | null; // '2024-03-21 13:54:45';
      deleted_at: null;
      description_overridden: 0 | 1;
      custom_description: null;
      fullUrl: string;
      progress: {
        completed: number;
        remaining: number;
        total: number;
        percent: string; // '3';
      };
      course: {
        id: number;
        name: string;
        slug: string;
        description: string;
        content: null;
        lft: number;
        rgt: number;
        depth: number;
        parent_id: null | number;
        created_at: string; // '2024-03-21 13:54:45';
        updated_at: string; // '2024-03-21 13:54:45';
        deleted_at: null;
        fullUrl: string;
      };
    };
  };
}

export interface CurrentProgression {
  current_step: CurrentStep | null;
  current_module: ProgressionEntity | null;
  current_cycle: ProgressionEntity | null;
  last_step: LastStep | null;
  current_lifeact_step?: ProgressionEntity;
}

export enum StepCategory {
  video = 'video',
  lifeact = 'lifeact',
  certificate = 'certificate',
}

export interface Step {
  category?: StepCategory | null;
  description: string;
  fullUrl: string;
  hideStepInMenu: boolean;
  id: number;
  lft?: number;
  name: string;
  status: EntityStatus;
  title: string;
  type: EntityType.step;
}

export interface Module {
  children: Step[];
  description: string;
  fullUrl: string;
  id: number;
  lft?: number;
  name: string;
  status: EntityStatus;
  title: string;
  type: EntityType.module;
}

export interface LevelProgression {
  completed: number;
  remaining: number;
  total: number;
  percent: `${number}`;
}

export interface Level {
  children: Module[];
  description: string;
  fullUrl: string;
  id: number;
  lft?: number;
  name: string;
  progress: LevelProgression;
  status: EntityStatus;
  title: string;
  type: EntityType.level;
}

export interface MenuData {
  id: number;
  name: string;
  fullUrl: string;
  status: 'current';
  children: Level[];
}

export interface MenuModel {
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
  next_page_url: string | null;
  prev_page_url: string | null;
  from: number;
  to: number;
  current_progression: CurrentProgression;
  menudata: [MenuData];
}

export interface StepDataPerSlug {
  [slug: string]: Step;
}
